import Button, { ButtonType } from "@/app/(components)/generics/Button/Button";
import IconRocket from "@/app/(components)/generics/Icons/IconRocket";
import { ModalStore } from "@/app/stores/ModalStore";
import { TKey } from "@/app/translations/TKey";
import { useT } from "@/app/translations/useT";
import { DefaultProps } from "@/app/types/common/DefaultProps";
import { HomeCtaAction } from "@/app/types/common/HomeCtaAction";
import { URecaptcha } from "@/app/utils/URecaptcha";
import { Globals } from "@/app/vars/Globals";

type Props = DefaultProps & {
  min?: boolean;
  label?: string;
  ctaKey?: TKey;
  hideIcon?: boolean;
  action?: HomeCtaAction;
};

export default function CTA(props: Props) {
  const T = useT();
  const {
    params,
    min = false,
    label,
    ctaKey,
    hideIcon = false,
    action = HomeCtaAction.DEMO,
  } = props;

  const isWaitlist = Globals.WAITLIST_ENABLED || action === HomeCtaAction.WAITLIST;

  const open = () => {
    if (isWaitlist) {
      ModalStore.getState().openWaitlist(params);
      return;
    }
    if (action === HomeCtaAction.SIGN_UP) {
      ModalStore.getState().openSignUp(params);
      return;
    }
    ModalStore.getState().openDemo();
  };

  return (
    <Button
      params={params}
      text={
        isWaitlist
          ? T(TKey.HOME_WAITLIST_CTA)
          : label
            ? label
            : ctaKey
              ? T(ctaKey)
              : T(TKey.HOME_CTA_BOOK_DEMO)
      }
      isLink={false}
      type={ButtonType.PRIMARY}
      onClick={open}
      onHover={isWaitlist ? URecaptcha.preload : undefined}
      min={min}
      beforeIcon={!hideIcon ? <IconRocket /> : undefined}
    />
  );
}
